module.exports = __webpack_public_path__ + "static/media/50.42c8b682.jpg";